<template>
  <div class="col-12 relative full-height flex items-center justify-center">
    <div class="center">
      <div class="list-loader-blue"></div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();

    const loading = computed(() => store.state.loadingContent);
    return { loading }
  }
}
</script>

<style>

</style>